





























import Vue from 'vue'

import IconAlarmFolder from '@/components/icons/icon-alarm-folder.vue'

export default Vue.extend({
  name: 'NavTag',
  components: {
    IconAlarmFolder,
  },
  data() {
    return {
      // eslint-disable-next-line
      expand: false,
    }
  },
  methods: {},
})
